import { useContext } from 'react';

import { WebviewBridgeContext } from './webview-bridge-context';
import { WebviewBridgeContextValue } from './webview-bridge-context.type';

/**
 * Hook to access webview bridge functionality
 *
 * @throws Error if used outside WebviewBridgeProvider
 */
export const useWebviewBridge = (): WebviewBridgeContextValue => {
  const context = useContext(WebviewBridgeContext);
  if (context === undefined) {
    throw new Error('useWebviewBridge must be used within a WebviewBridgeProvider');
  }
  return context;
};
